export interface IImage {
  person: string;
  original: any;
  small: any;
  medium: any;
  large: any;
  timestamp: Date;
}

export enum ImageSize {
  original = "original",
  small = "small",
  medium = "medium",
  large = "large",
}
